import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TpButtonModule } from 'app/components/tp-button/tp-button.module';
import { TpDropdownModule } from 'app/components/tp-dropdown/tp-dropdown.module';
import { TpEmailBuilderComponent } from './tp-email-builder.component';

@NgModule({
    declarations: [TpEmailBuilderComponent],
    imports: [CommonModule, FormsModule, TpDropdownModule, TpButtonModule],
    exports: [TpEmailBuilderComponent],
})
export class TpEmailBuilderModule {}
